export default __webpack_public_path__ + "static/media/join.6d8cf15e.svg";